// src/store.js
import { configureStore } from '@reduxjs/toolkit';
import supportReducer from './features/support/supportSlice';

const store = configureStore({
  reducer: {
    support: supportReducer,
  },
});

export default store;